export default "__VITE_ASSET__4ff21583__"